import { createModel } from '@/store/tools';

const model = {
    namespace: 'agent',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getAgentList': T('getAgentList'),
            'getAgentState': T('getAgentState'),
            'getAgentDetail': T('getAgentDetail'),
            'getRecommentList': T('getRecommentList'),
            'getRecommentType': T('getRecommentType'),
            'getAgentAccountSummary': T('getAgentAccountSummary'),
            'getOperateType': T('getOperateType'),
            'getTotalIncome': T('getTotalIncome'),
            'getDrawable': T('getDrawable'),
            'getTotalDrawable': T('getTotalDrawable'),
            'getInvite': T('getInvite'),
        },
        actions: {
            'getAgentList': A('getAgentList'),
            'getAgentState': A('getAgentState', { enumName: 'UserStatusEnum' }),
            'getAgentDetail': A('getAgentDetail'),
            'getRecommentList': A('getRecommentList'),
            'getRecommentType': A('getRecommentType', { enumName: 'BrokerReferrerTypeEnum' }),
            'getAgentAccountSummary': A('getAgentAccountSummary'),
            'getOperateType': A('getOperateType', { enumName: 'AgentAppChangeType' }),
            'getTotalIncome': A('getTotalIncome'),
            'getDrawable': A('getDrawable'),
            'getTotalDrawable': A('getTotalDrawable'),
            'getInvite': A('getInvite'),
        },
        sagas: {
            'getAgentList': S('getAgentList', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.listBrokerInfo'),
            'getAgentState': S('getAgentState', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAgentDetail': S('getAgentDetail', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.getUserBrokerInfo'),
            'getRecommentList': S('getRecommentList', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.listBrokerReferrer'),
            'getRecommentType': S('getRecommentType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getAgentAccountSummary': S('getAgentAccountSummary', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountApiMisService.selectSettleAccount'),
            'getOperateType': S('getOperateType', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getTotalIncome': S('getTotalIncome', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.settleIncomeList'),
            'getDrawable': S('getDrawable', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.totalBalanceList'),
            'getTotalDrawable': S('getTotalDrawable', '/?cmd=com.xqxc.api.pig.mis.settle.SettleAccountDetailApiMisService.totalWithdrawList'),
            'getInvite': S('getInvite', '/?cmd=com.xqxc.api.pig.mis.biz.account.UserAccountMisService.getInviteBrokerInfo'),
        },
        reducers: {
            'getAgentList': R('getAgentList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getAgentState': R('getAgentState', []),
            'getAgentDetail': R('getAgentDetail', {}),
            'getRecommentList': R('getRecommentList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getRecommentType': R('getRecommentType', []),
            'getAgentAccountSummary': R('getAgentAccountSummary', {}),
            'getOperateType': R('getOperateType', []),
            'getTotalIncome': R('getTotalIncome', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getDrawable': R('getDrawable', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getTotalDrawable': R('getTotalDrawable', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getInvite': R('getInvite', {}),
        }
    })
};
export default createModel(model);